import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from "react-router-dom";

import { GetCorporateByID, ReservationPMSDetails, SaveResCorporateDetail } from '../../Services/Service';
import { useParams } from "react-router-dom";
import ReservationSidebar from '../Commun/ReservationSidebar';
import ReservationHeader from '../Commun/ReservationHeader';
import { useProperty } from '../../PropertyContext';


const ReservationNewCompany = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { selectedProperty } = useProperty();
    const [loading, setLoading] = useState(false);
    const [images, setImages] = useState([]);
    const [formData, setFormData] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [results, setResults] = useState([]);
    const [isPushMealPlan, setIsPushMealPlan] = useState(0);

    const { id } = useParams();

    const handleImageChange = (e) => {
        const files = Array.from(e.target.files);
        const newImages = files.map(file => ({
            file,
            url: URL.createObjectURL(file)
        }));
        setImages(prev => [...prev, ...newImages]);
    };

    const removeImage = (indexToRemove) => {
        setImages(prev =>
            prev.filter((_, index) => index !== indexToRemove)
        );
    };


    const handleSubmit = async (e) => {
        setLoading(true);
        e.preventDefault();

        const form = new FormData(e.target);
        const data = Object.fromEntries(form.entries());

        const payload = {
            CorporateID: formData?.CorporateID || 0,
            LoginID: parseInt(localStorage.getItem("UserLoginID") || 0),
            FirstName: data.firstName,
            MidlleName: data.middleName,
            LastName: data.lastName,
            DOB: data.dob || null,
            Gender: data.gender || "",
            Address: data.address,
            City: data.city,
            State: data.state,
            Country: data.country,
            PinCode: data.pinCode,
            Status: 1,
            CreatedBy: null,
            CreatedDateTime: new Date().toISOString(),
            ModifyBY: null,
            ModifyDateTime: new Date().toISOString(),
            TA_Name: data.companyName,
            Website: data.companyWebsite,
            MobileNo: data.mobileNumber,
            TelNo: data.telephoneNumber,
            TelEx: data.extension,
            Gst: data.gstNumber,
            Pan: data.panNumber,
            AgencyLogo: "", // you can handle base64 or image upload later
            Area: "",
            Hotel: localStorage.getItem("SelectedPropertyID"),
            AccountManager: "0",
            CorporateCode: "", // Backend may generate or add UI field
            PMSCode: data.pmsCode,
            MarketSegment: data.marketSegment || null,
            BusinessSource: data.businessSource || null,
            BillingInstructions: data.billingInstructions || null,
            IsPushMealPlan: isPushMealPlan,
            MaxRoomBook: parseInt(data.maxRoomBook) || 0,
        };

        try {
            const res = await SaveResCorporateDetail(payload, selectedProperty?.PropertyID);
            console.log("Success:", res);

            navigate("/Reservation/CompanyList", {
                state: {
                    showSuccess: true,
                    successMessage: "Corporate Detail Saved Successfully"
                }
            });
        } catch (err) {
            console.error("Error:", err);
            alert("Failed to save corporate detail");
        } finally {
            setLoading(false);
        }
    };


    // useEffect(() => {
    //     if (id) {
    //         getCorporateByID(id).then((res) => {
    //             setFormData(res);
    //         });
    //     }
    // }, [id]);


    useEffect(() => {
        const load = async () => {
            // 1) prefer navigation state if available
            if (location.state?.corporateItem) {
                const item = location.state.corporateItem;
                setFormData(item);
                setIsPushMealPlan(Number(item?.IsPushMealPlan) || 0);
                return;
            }

            // 2) fallback to fetch by id + property
            if (id && selectedProperty?.PropertyID) {
                setLoading(true);
                try {
                    // prefer the service that accepts propID
                    const res = await GetCorporateByID(id, selectedProperty.PropertyID);
                    // or: const res = await GetResCorporateByID(id, selectedProperty.PropertyID);
                    if (res) {
                        setFormData(res);
                        setIsPushMealPlan(Number(res?.IsPushMealPlan) || 0);
                    } else {
                        console.warn("No corporate record found for id:", id);
                    }
                } catch (err) {
                    console.error("Error fetching corporate by id:", err);
                } finally {
                    setLoading(false);
                }
            }
        };

        load();
    }, [id, location.state, selectedProperty]);


    const handlePMSDetailSearch = async (e) => {
        e.preventDefault();
        if (!searchTerm.trim()) return;

        try {

            setLoading(true);

            const res = await ReservationPMSDetails(searchTerm, "company", selectedProperty?.PropertyID); // passing Name + ProfileType

            const profiles = res?.Result?.profileSummaries?.profileInfo || [];
            setResults(profiles);
        } catch (error) {
            console.error("Search error:", error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        const modal = document.querySelector(".bs-example-modal-lg");

        const handleModalClose = () => {
            setSearchTerm("");  // input reset
            setResults([]);    // results reset
        };

        if (modal) {
            modal.addEventListener("hidden.bs.modal", handleModalClose);
        }

        return () => {
            if (modal) {
                modal.removeEventListener("hidden.bs.modal", handleModalClose);
            }
        };
    }, []);

    const handleSelectCompany = (company) => {
        const profile = company.profile;

        setFormData((prev) => ({
            ...prev,
            TA_Name: profile.formerName?.name || "",
            Address: profile.addressInfo?.address?.addressLine?.filter(Boolean).join(", ") || "",
            City: profile.addressInfo?.address?.cityName || "",
            State: profile.addressInfo?.address?.state || "",
            Country: profile.addressInfo?.address?.country?.value || "",
            PinCode: profile.addressInfo?.address?.postalCode || "",
        }));

        // Close bootstrap modal
        const modal = document.querySelector(".bs-example-modal-lg");
        if (modal) {
            const bootstrapModal = window.bootstrap.Modal.getInstance(modal);
            bootstrapModal.hide();
        }
    };



    return (
        <>
            {loading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
                </div>
            )}

            <div className="wrapper">
                <ReservationSidebar />
                <div className="main-panel">
                    <ReservationHeader />

                    <div className="container">
                        <div className="page-inner">

                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="card-title">Corporate Registration</div>
                                        </div>
                                        <form onSubmit={handleSubmit}>
                                            <div className="card-body">

                                                <h4 className="card-title">Personal Information</h4>
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="input-block ">
                                                            <label className="col-form-label" htmlFor="companyName">Name of The Company</label>
                                                            <div className='d-flex'>
                                                                <input type="text" className="form-control" id="companyName" name='companyName' placeholder="Name of The Company" defaultValue={formData?.TA_Name || ""} required />
                                                                <button type="button" class="btn " data-bs-toggle="modal" data-bs-target=".bs-example-modal-lg"><i className='fas fa-search'></i></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="input-block ">
                                                            <label className="col-form-label" htmlFor="state">State</label>
                                                            <input type="text" className="form-control" id="state" name='state' placeholder="State" defaultValue={formData?.State || ""} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="input-block ">
                                                            <label className="col-form-label" htmlFor="country">Country</label>
                                                            <input type="text" className="form-control" id="country" name='country' placeholder="Country" defaultValue={formData?.Country || ""} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <div className="input-block ">
                                                            <label className="col-form-label" htmlFor="city">City</label>
                                                            <input type="text" className="form-control" id="city" name='city' placeholder="City" required defaultValue={formData?.City || ""} />
                                                        </div>
                                                    </div>


                                                    <div className="col-md-3">
                                                        <div className="input-block ">
                                                            <label className="col-form-label" htmlFor="firstName">Contact Person First Name</label>
                                                            <input type="text" className="form-control" id="firstName" name='firstName' placeholder="First Name" defaultValue={formData?.FirstName || ""} required />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="input-block ">
                                                            <label className="col-form-label" htmlFor="middleName">Middle Name</label>
                                                            <input type="text" className="form-control" id="middleName" name='middleName' placeholder="Middle Name" defaultValue={formData?.MidlleName || ""} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="input-block ">
                                                            <label className="col-form-label" htmlFor="lastName">Last Name</label>
                                                            <input type="text" className="form-control" id="lastName" name='lastName' placeholder="Last Name" defaultValue={formData?.LastName || ""} required />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="input-block ">
                                                            <label className="col-form-label" htmlFor="pinCode">Pin Code</label>
                                                            <input type="text" className="form-control" id="pinCode" name='pinCode' placeholder="Pin Code" defaultValue={formData?.PinCode || ""} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="input-block ">
                                                            <label className="col-form-label" htmlFor="address">Address</label>
                                                            <textarea id="address" name='address' rows="2" className="form-control" placeholder="Address" defaultValue={formData?.Address || ""}></textarea>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="input-block ">
                                                            <label className="col-form-label" htmlFor="companyWebsite">Company Website</label>
                                                            <input type="text" className="form-control" id="companyWebsite" name='companyWebsite' placeholder="Company Website" defaultValue={formData?.Website || ""} />
                                                        </div>
                                                    </div>
                                                </div>

                                                <h4 className="card-title">Contact Information</h4>
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <div className="input-block ">
                                                            <label className="col-form-label" htmlFor="mobileNumber">Mobile Number</label>
                                                            <input type="number" className="form-control" id="mobileNumber" name='mobileNumber' placeholder="Mobile Number" defaultValue={formData?.MobileNo || ""} required />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="input-block ">
                                                            <label className="col-form-label" htmlFor="telephoneNumber">Telephone Number</label>
                                                            <input type="number" className="form-control" id="telephoneNumber" name='telephoneNumber' placeholder="Telephone Number" defaultValue={formData?.TelNo || ""} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="input-block ">
                                                            <label className="col-form-label" htmlFor="extension">Extension</label>
                                                            <input type="text" className="form-control" id="extension" name='extension' placeholder="Extension" defaultValue={formData?.TelEx || ""} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="input-block ">
                                                            <label className="col-form-label" htmlFor="dob">Date of Birth</label>
                                                            <input type="date" className="form-control" id="dob" name='dob' defaultValue={formData?.DOB ? formData.DOB.split("T")[0] : ""} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <div className="input-block ">
                                                            <label className="col-form-label" htmlFor="gender">Gender</label>
                                                            <select id="gender" className="form-control form-select" defaultValue={formData?.Gender || ""}>
                                                                <option>Select Gender</option>
                                                                <option>Male</option>
                                                                <option>Female</option>
                                                                <option>Other</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="input-block ">
                                                            <label className="col-form-label" htmlFor="email">Email</label>
                                                            <input type="email" className="form-control" id="email" name='email' placeholder="Email" defaultValue={formData?.Email || ""} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="input-block ">
                                                            <label className="col-form-label" htmlFor="password">Password</label>
                                                            <input type="password" className="form-control" id="password" name='password' placeholder="Password" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="input-block ">
                                                            <label className="col-form-label" htmlFor="confirmPassword">Confirm Password</label>
                                                            <input type="password" className="form-control" id="confirmPassword" name='confirmPassword' placeholder="Confirm Password" />
                                                        </div>
                                                    </div>
                                                </div>

                                                <h4 className="card-title">Company Details</h4>
                                                <div className="row">
                                                    {/* GST, PAN, PMS in one line */}
                                                    <div className="col-md-4">
                                                        <div className="input-block ">
                                                            <label className="col-form-label" htmlFor="gstNumber">GST Number</label>
                                                            <input type="text" className="form-control" id="gstNumber" name='gstNumber' placeholder="GST Number" defaultValue={formData?.Gst || ""} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="input-block ">
                                                            <label className="col-form-label" htmlFor="panNumber">PAN Number</label>
                                                            <input type="text" className="form-control" id="panNumber" name='panNumber' placeholder="PAN Number" defaultValue={formData?.Pan || ""} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="input-block ">
                                                            <label className="col-form-label" htmlFor="pmsCode">PMS Code</label>
                                                            <input type="text" className="form-control" id="pmsCode" name='pmsCode' placeholder="PMS Code" defaultValue={formData?.PMSCode || ""} />
                                                        </div>
                                                    </div>

                                                    {/* Image Upload Full Width */}
                                                    <div className="col-12">
                                                        <div className="input-block ">
                                                            <label className="col-form-label" htmlFor="imageUpload">Company Logo</label>
                                                            <div className="d-flex gap-3 flex-wrap">
                                                                {images.map((img, index) => (
                                                                    <div
                                                                        key={index}
                                                                        style={{
                                                                            width: '120px',
                                                                            height: '100px',
                                                                            borderRadius: '10px',
                                                                            overflow: 'hidden',
                                                                            position: 'relative'
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src={img.url}
                                                                            alt={`preview-${index}`}
                                                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                                        />
                                                                        <button
                                                                            type="button"
                                                                            onClick={() => removeImage(index)}
                                                                            style={{
                                                                                position: 'absolute',
                                                                                top: '5px',
                                                                                right: '5px',
                                                                                background: '#fff',
                                                                                border: 'none',
                                                                                borderRadius: '50%',
                                                                                width: '24px',
                                                                                height: '24px',
                                                                                padding: 0,
                                                                                textAlign: 'center',
                                                                                lineHeight: '20px',
                                                                                fontWeight: 'bold',
                                                                                color: '#333',
                                                                                cursor: 'pointer',
                                                                                boxShadow: '0 0 5px rgba(0,0,0,0.2)'
                                                                            }}
                                                                        >
                                                                            ×
                                                                        </button>
                                                                    </div>
                                                                ))}

                                                                {/* Upload Box */}
                                                                <label
                                                                    htmlFor="imageUpload"
                                                                    style={{
                                                                        width: '120px',
                                                                        height: '100px',
                                                                        border: '2px dashed #ccc',
                                                                        borderRadius: '10px',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        cursor: 'pointer'
                                                                    }}
                                                                >
                                                                    <div style={{ textAlign: 'center', color: '#999' }}>
                                                                        <i className="fas fa-image" style={{ fontSize: '20px' }}></i><br />
                                                                        Add Image
                                                                    </div>
                                                                    <input
                                                                        id="imageUpload"
                                                                        type="file"
                                                                        accept="image/*"
                                                                        multiple
                                                                        onChange={handleImageChange}
                                                                        style={{ display: 'none' }}
                                                                    />
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                                <h4 className="card-title">Additional Information</h4>
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="input-block ">
                                                            <label className="col-form-label" htmlFor="marketSegment">Market Segment</label>
                                                            <select id="marketSegment" className="form-control form-select" defaultValue={formData?.MarketSegment || ""}>
                                                                <option>Select Market Segment</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="input-block ">
                                                            <label className="col-form-label" htmlFor="businessSource">Business Source</label>
                                                            <select id="businessSource" className="form-control form-select" defaultValue={formData?.BusinessSource || ""}>
                                                                <option>Select Business Source</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-4">
                                                        <div className="input-block ">
                                                            <label className="col-form-label" htmlFor="billingInstructions">Billing Instructions</label>
                                                            <select id="billingInstructions" className="form-control form-select" defaultValue={formData?.BillingInstructions || ""}>
                                                                <option>Select Billing Instructions</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='col-md-3'>
                                                    <div className="input-block mb-3">
                                                        <label className="col-form-label" >Maximum Room Can book</label>
                                                        <input type='number' className='form-control' name='maxRoomBook' defaultValue={formData?.MaxRoomBook || 0} min={0} />
                                                    </div>
                                                </div>

                                                <div className="col-md-2">
                                                    <div className="input-block mb-3">
                                                        <label className="col-form-label">Meal Plan send</label>
                                                        <div className='d-flex gap-2'>
                                                            <input
                                                                type='radio'
                                                                name='isPushMealPlan'
                                                                value={1}
                                                                checked={isPushMealPlan === 1}
                                                                onChange={() => setIsPushMealPlan(1)}
                                                            />
                                                            <label className='form-label mt-1 me-4'>Yes</label>

                                                            <input
                                                                type='radio'
                                                                name='isPushMealPlan'
                                                                value={0}
                                                                checked={isPushMealPlan === 0}
                                                                onChange={() => setIsPushMealPlan(0)}
                                                            />
                                                            <label className='form-label mt-1'>No</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card-action text-end">
                                                <button type="submit" className="btn btn-primary">Register Now</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <>
                        {/*  Large modal example */}
                        <div
                            className="modal fade bs-example-modal-lg"
                            tabIndex={-1}
                            role="dialog"
                            aria-labelledby="myLargeModalLabel"
                            aria-hidden="true"
                        >
                            <div className="modal-dialog modal-lg">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title" id="myLargeModalLabel">
                                            Search company
                                        </h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                        ></button>
                                    </div>
                                    <div className="modal-body">
                                        <div className='row'>
                                            <div className='col-ms-12'>
                                                <form className='row' onSubmit={handlePMSDetailSearch}>
                                                    <div className='col-md-4'>
                                                        <div className='mb-3'>
                                                            <input type='text' className='form-control' placeholder="Search here..." value={searchTerm}
                                                                onChange={(e) => setSearchTerm(e.target.value)} />
                                                        </div>
                                                    </div>
                                                    <div className='col-md-1'>
                                                        <div className='mb-3'>
                                                            <button type='submit' className='btn btn-primary' >Search</button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className='col-md-12'>

                                                <div className='table-responsive'>
                                                    <table className='table '>
                                                        <thead>
                                                            <tr>
                                                                <th>Sr #</th>
                                                                <th>Name</th>
                                                                <th>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {results.length > 0 ? (
                                                                results.map((item, index) => (
                                                                    <tr key={item.profileIdList?.[0]?.id || index}>
                                                                        <td>{index + 1}</td>
                                                                        <td>{item.profile?.formerName?.fullName}</td>
                                                                        <td>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-primary"
                                                                                onClick={() => handleSelectCompany(item)}
                                                                            >
                                                                                Select
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="3" className="text-center">
                                                                        {loading
                                                                            ? "Searching..."
                                                                            : "No results. Please search other comapny."}
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                {/* /.modal-content */}
                            </div>
                            {/* /.modal-dialog */}
                        </div>
                        {/* /.modal */}
                    </>
                </div>
            </div>
        </>
    )
}

export default ReservationNewCompany;
